/**
 * @fileoverview "Not seen by your teacher" (F7).
 *
 * Decision D-S1's build requirement, and the reason the whole family tier is
 * defensible: feedback a HOUSEHOLD paid for is released without waiting for
 * the instructor, so it must never be mistakable for the teacher's own words.
 *
 * One component so the sentence is identical everywhere it appears. Two
 * surfaces render this today and both are read by a child; a second wording
 * is a second promise.
 *
 * Deliberately a plain note rather than a warning: nothing has gone wrong,
 * and dressing honest AI feedback in an error colour would teach a student to
 * distrust the thing their parent is paying for.
 */

export function UnreviewedAiNotice({ className = "" }) {
  return (
    <p
      className={`font-sans text-[12px] italic text-[var(--text-tertiary)] ${className}`}
      data-testid="ai-unreviewed"
    >
      Written by Hans, not yet seen by your teacher.
    </p>
  );
}

export default UnreviewedAiNotice;
